export default __webpack_public_path__ + "static/loop-241e7bd6ea5e64d032c59b3b65159e36.png";